import { render } from "./FirewallTagTab.vue?vue&type=template&id=6e16517a"
import script from "./FirewallTagTab.vue?vue&type=script&lang=js"
export * from "./FirewallTagTab.vue?vue&type=script&lang=js"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__